import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const createApplicantJobAction = (formData) => ({
  type: actions.CREATE_JAPPLICANT,
  payload: formData,
});

export const createSingleApplicantJobAction = (formData) => ({
  type: actions.GET_SINGLE_JAPPLICANT,
  payload: formData,
});

export const updateApplicantJobAction = (id, formData) => ({
  type: actions.UPDATE_JAPPLICANT,
  payload: {
    id,
    formData,
  },
});

export const updateApplicantApplicantStatusAction = (formData) => ({
  type: actions.UPDATE_JAPPLICANT_APPLICANT_STATUS,
  payload: formData,
});
// Plural
export const getApplicantJobsAction = (body) => ({
  type: actions.GET_JAPPLICANT,
  payload : body
});
export const getApplicantJobsRecmAction = (body) => ({
  type: actions.GET_JAPPLICANT_RECOM,
  payload : body
});

export const getApplicantJobsPendingAction = (body) => ({
  type: actions.GET_JAPPLICANT_PENDING,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const createApplicantJobSuccessAction = (job) => ({
  type: actions.CREATE_JAPPLICANT_SUCCESS,
  payload: job,
});

export const updateApplicantApplicantStatusSuccessAction = (job) => ({
  type: actions.UPDATE_JAPPLICANT_APPLICANT_STATUS_SUCCESS,
  payload: job,
});

export const updateApplicantJobSuccessAction = (job) => ({
  type: actions.UPDATE_JAPPLICANT_SUCCESS,
  payload: job,
});
// Plural
export const getApplicantJobsSuccessAction = (ApplicantJobs) => ({
  type: actions.GET_JAPPLICANT_SUCCESS,
  payload: ApplicantJobs,
});export const getApplicantJobsRecmSuccessAction = (ApplicantJobs) => ({
  type: actions.GET_JAPPLICANT_RECOM_SUCCESS,
  payload: ApplicantJobs,
});
export const getSingleApplicantJobSuccessAction = (ApplicantJob) => ({
  type: actions.GET_SINGLE_JAPPLICANT_SUCCESS,
  payload: ApplicantJob,
});

export const getApplicantJobsPendingSuccessAction = (ApplicantJobs) => ({
  type: actions.GET_JAPPLICANT_PENDING_SUCCESS,
  payload: ApplicantJobs,
});

export const deleteJobAction = (id) => ({
  type: actions.DELETE_JAPPLICANT,
  payload: id,
});

export const deleteJobSuccessAction = (jobId) => ({
  type: actions.DELETE_JAPPLICANT_SUCCESS,
  payload: jobId,
});


/**
 * Misc
 */
export const setApplicantJobsIsLoadingAction = (isLoading) => ({
  type: actions.SET_JAPPLICANT_IS_LOADING,
  payload: isLoading,
});

export const setApplicantJobsCountAction = (count) => ({
  type: actions.SET_JAPPLICANT_COUNT,
  payload: count,
});

export const setSearchValueAction = value => ({
  type : actions.SET_AT_SEARCH_VALUE,
  payload : value
})